import React from 'react';
import '../dashboard/Createcampaign.css';

interface NavigationButtonProps {
  step: number;
  steps: number;
  handleNext: () => void;
  handleBack: () => void;  // Add handleBack to props
  handleSubmit: () => void;
  isSubmitting: boolean;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
  step,
  steps,
  handleNext,
  handleBack,
  handleSubmit,
  isSubmitting,
}) => {
  return (
    <div style={{ marginTop: '20px', padding: '0px 0px 20px 0px', display: 'flex', width: '100%', alignItems: 'center'}}>

      {/* Back Button */}
      {step > 1 && (
        <button
          style={{
            width: "13%",
            marginRight: '10px',
            // paddingRight: '0px',
            marginLeft: '30%',
            borderRadius:'0px'
          }}
          className="function-button" 
          onClick={handleBack}
        >
          Back
        </button>
      )}

      {/* Create Desktop Ad Button */}
      {step === 1 && (
        <button
          style={{
            width: "13%",
            borderRadius:'0px',
            fontSize:'13px'
          }}
          className="function-button" 
          onClick={handleNext}
        >
          Create Desktop Ad
        </button>
      )}

      {/* Create Mobile Ad Button */}
      {step === 1 && (
        <button 
          style={{
            width: "13%",
            marginRight: 'auto',
            paddingRight: '0px',
            marginLeft: '0px',
            borderRadius:'0px',
            fontSize:'13px'


          }}
          className="function-button" 
          onClick={handleNext}
        >
          Create Mobile Ad
        </button>
      )}

      {/* Next or Submit Button */}
      {step < steps && step > 1 && (
        <button
          style={{
            width: "13%",
            marginRight: '150px',
            paddingRight: '0px',
            marginLeft: '10px',
            borderRadius:'0px'
          }}
          className="function-button" 
          onClick={handleNext}
        >
          Next
        </button>
      )}

      {/* Submit Button */}
      {step === steps && (
        <button 
        style={{
          width: "17%",
          marginRight: '150px',
          paddingRight: '0px',
          marginLeft: '10px',
        }}
        className="function-button" 
        
        onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      )}
    </div>
  );
};

export default NavigationButton;
